var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('message-modal'),_c('div',[_c('main-header'),_c('iframe',{staticClass:"precarriage-v2-iframe",attrs:{"src":_vm.precarriageV2Url,"title":"Precarriage V2","frameborder":"0"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }